export const hasTab = (key: string, tabs: string[]) => !!tabs.find((x) => x === key);
export const getLargestTab = (tabs: string[]) => Math.max(...tabs.map((x) => x.length));
